import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {OauthService} from '../../../shared/services/oauth.service';
import {App} from 'ionic-angular';
import {Http} from '@angular/http';
import {ToolsService} from '../../../shared/services/tools.service';
import {AppProvider} from "../../../core/app/app-provider.service";

@Injectable()
export class LostPasswordService extends OauthService {

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);
  }

  lostPassword(credentials) {
    const url = this.Routing.generate('api_post_utilisateur_password_reset', {'_format': 'json'}, true);
    let formData: string;
    formData = this.getFormData(credentials);

    return this.http
      .post(url, formData, {headers: this.formDataHeaders})
      .map(res => res.json());
  }

  resetPassword(credentials) {
    const url = this.Routing.generate('api_post_utilisateur_password_reset_token', null, true);
    const data: object = {
      'plainPassword': {
        'first': credentials.password,
        'second': credentials.repeatPassword,
      }
    };

    const headers: any = {
      'Content-Type': 'application/json'
    };

    // @ts-ignore
    return this.http
      .post(`${url}/${credentials.code}`, JSON.stringify(data), {headers})
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/pages/lost-password/services/lost-password.service.ts